import React, { useState, useEffect } from "react";
import styled from "styled-components";
import SearchCross from "../../../assets/img/icons/SearchCross.svg";
import Scroll from "react-scroll";
import store from "store";
import { ReactComponent as ReloadIcon } from "../../../assets/img/icons/reload.svg";
import { setSearchCampaignName } from "../CampaignAssets/actions";
import { CAMPAIGNS_LIST } from "constants/types";
interface Props {
  firstTime?: boolean;
  setSearchFilter?: (value: string) => void;
  filteredCampaigns?: (value: string, value2: any, value3?: any) => void;
  searchFilter?: string;
  searchValue?: string;
  datesObj?: any;
}

const CampaignSearch: React.FC<Props> = ({
  firstTime,
  searchFilter,
  searchValue,
  setSearchFilter = () => {},
  filteredCampaigns,
  datesObj, // {start_date, end_date}
}: Props) => {
  var scroller = Scroll.scroller;
  const [value, setValue] = useState("");

  const submitHandler = (e: any) => {
    e.preventDefault();

    if (searchFilter !== value) {
      store.dispatch({
        type: CAMPAIGNS_LIST.RESET,
      });
      store.dispatch({
        type: CAMPAIGNS_LIST.ERROR_SEARCH_TERM,
        message: "",
        success: true,
      });
      setSearchFilter(value);
      searchValue = value;
      if (filteredCampaigns) filteredCampaigns("search", value, datesObj);
    }

    scroller.scrollTo("myCampaignsDiv", {
      duration: 800,
      delay: 0,
      offset: -80,
      smooth: "easeInOutQuart",
    });
  };

  const handleInput = (e: any) => {
    if (e.target.value.length === 0) {
      setValue("");
      setSearchFilter("");
      if (filteredCampaigns) filteredCampaigns("search", "", datesObj);
    }
    setValue(e.target.value);
  };

  const handleReload = () => {
    if (value.length > 0) {
      setSearchFilter(value);
      searchValue = value;
      if (filteredCampaigns) filteredCampaigns("search", value, datesObj);
    }
    scroller.scrollTo("myCampaignsDiv", {
      duration: 800,
      delay: 0,
      offset: -80,
      smooth: "easeInOutQuart",
    });
  };

  useEffect(() => {
    setValue(value);
  }, [value]);

  return (
    <>
      <Wrapper>
        <div className="search-wrapper">
          <form onSubmit={submitHandler}>
            <div className="search-bar">
              <span className="refresh-search">
                <ReloadIcon onClick={handleReload} />
              </span>
              <input
                type="text"
                name="search"
                className="search-input"
                placeholder="Search for campaigns..."
                onChange={(e) => {
                  handleInput(e);
                  // setValue(e.target.value);
                }}
                value={value}
              />
              {value.length > 0 ? (
                <span className="clear-search">
                  <img
                    src={SearchCross}
                    onClick={() => {
                      setValue("");
                      setSearchFilter("");
                      if (filteredCampaigns) filteredCampaigns("search", "", datesObj);
                    }}
                    alt="icon"
                  />
                </span>
              ) : null}
            </div>
          </form>
        </div>
      </Wrapper>
    </>
  );
};

export default CampaignSearch;

const Wrapper = styled.div`
  width: 100%;
  .search-wrapper {
    position: relative;
    width: 100%;
    .search-results {
      border-radius: 22px;
      position: absolute;
      top: -80px;
      left: 0;
      // display: none;
      float: left;
      width: 100%;
      border: 1px solid #dadada;
      box-shadow: 0 0 24px 0 rgba(0, 0, 0, 0.12);
      overflow: hidden;
      transition: 0.5s;
      z-index: -1;
      opacity: 0;
      visibility: hidden;
      &.show {
        opacity: 1;
        z-index: 1;
        visibility: visible;
      }
      ul.results-list {
        background: #fff;
        padding: 30px 55px 10px 55px;
        margin: 0;
        list-style: none;
        float: left;
        display: block;
        width: 100%;
        transition: 0.5s;
        li {
          color: #5e7079;
          font-size: 16px;
          line-height: 34px;
          padding: 0;
          list-style: none;
          float: left;
          width: 100%;
          display: block;
          cursor: pointer;
          transition: 0.5s;
        }
      }
      .relevant-theme,
      .relevant-company {
        border-top: 1px solid #dadada;
        padding: 10px 40px 30px 40px;
        background: #f7f7f7;
        float: left;
        width: 100%;
        transition: 0.5s;
        h3 {
          margin-bottom: 10px;
          color: #424b50;
          font-weight: 400;
          font-family: "Roboto Slab", serif;
          font-size: 18px;
          line-height: 34px;
        }
      }
      .search-hint {
        background: #def6e6;
        padding: 18px 25px 36px 25px;
        border-radius: 22px 22px 0 0;
        float: left;
        width: 100%;
        svg {
          float: left;
          width: 35px;
          height: 39px;
        }
        ul {
          margin: 0;
          float: left;
          li {
            color: #09a43a;
            font-size: 14px;
            font-weight: 400;
            list-style: none;
            strong {
              font-weight: 700;
            }
          }
        }
      }
    }
    .search-bar {
      border-radius: 27px;
      background: #ffffff;
      border: 1px solid #dadada;
      display: block;
      float: left;
      width: 100%;
      overflow: hidden;
      position: relative;
      span.clear-search {
        float: left;
        margin: 6px 8px;
        transition: 0.5s;
        cursor: pointer;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          margin: 3px 8px 3px 8px;
          float: right;
        }
        img {
          @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
            width: 9px;
            height: auto;
          }
        }
      }
      span.refresh-search {
        padding-right: 5px;
        border-right: 1px solid #dadada;
        margin: 6px;
        float: left;
        cursor: pointer;
        svg path {
          fill: #424b50;
        }
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          line-height: 13px;
        }
        svg {
          @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
            width: 14px;
            height: auto;
            vertical-align: bottom;
          }
        }
      }
      .search-input {
        float: left;
        border: none;
        outline: none;
        width: calc(100% - 80px);
        display: block;
        color: #424b50;
        font-weight: 400;
        font-size: 18px;
        margin-top: 3px;
        font-family: "robotoregular";
        -webkit-box-shadow: 0 0 0 30px white inset !important;
        letter-spacing: -0.5px;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          font-size: 13px;
          margin-top: 2px;
          width: calc(100% - 60px);
        }
        &::-webkit-input-placeholder {
          font-family: "robotothin_italic";
          color: #c1c1c1;
        }
        &:-moz-placeholder {
          font-family: "robotothin_italic";
          color: #c1c1c1;
        }
        &::-moz-placeholder {
          font-family: "robotothin_italic";
          color: #c1c1c1;
        }
        &:-ms-input-placeholder {
          font-family: "robotothin_italic";
          color: #c1c1c1;
        }
        &:hover,
        &:active,
        &:focus {
          border: none;
          outline: none;
        }
      }
    }
  }
`;
